<template>
  <b-modal
    id="modal-course-detail"
    centered
    hide-footer
    title="Course Detail"
    size="xl"
    body-class="p-0"
  >
    <div class="modal-body-custom">
      <!-- Alert Info -->
      <div
        class="alert mb-0 rounded-0 border-0 d-flex align-items-center justify-content-between"
        style="background-color: #fafafa"
      >
        <div>
          <i class="fe fe-info text-warning me-2" style="font-size: 1.2rem"></i>
          <span class="text-dark"
            >You can manage this course with this action</span
          >
        </div>
        <!-- Action Buttons (Top Right) -->
        <div class="d-flex justify-content-end gap-2 mb-3">
          <button class="btn btn-sm btn-info" @click="editCourse">
            <i class="fe fe-edit me-1"></i>
            Edit
          </button>
          <button class="btn btn-sm btn-danger" @click="deleteCourse">
            <i class="fe fe-trash me-1"></i>
            Delete
          </button>
        </div>
      </div>

      <!-- Course Content -->
      <div class="row g-0">
        <!-- Left Side - Course Info -->
        <div class="col-md-12 p-4 border-end">
          <!-- Schedule Badge -->
          <div class="row">
            <div
              class="col-md-7"
              style="
                display: flex;
                flex-direction: column;
                justify-content: space-between;
              "
            >
              <!-- Status Badge -->
              <div class="mb-3">
                <span
                  :class="
                    courseData && courseData?.is_active
                      ? 'badge bg-success'
                      : 'badge bg-warning'
                  "
                  style="padding: 0.35rem 0.75rem"
                >
                  <i class="fe fe-info me-1"></i>
                  {{ courseData?.training_status || "-" }}
                </span>
              </div>
              <!-- Course Title -->
              <h3 class="mb-3 font-weight-bold" style="color: #1a202c">
                {{ courseData ? courseData?.title : "-" }}
              </h3>

              <!-- Category Badges -->
              <div class="mb-4 d-flex gap-2">
                <span class="badge-icon bg-danger-soft text-danger">
                  <i
                    :class="getTrainingTypeIcon(courseData?.training_type)"
                  ></i>
                </span>
                <span class="badge-custom bg-warning-soft text-warning">
                  {{ courseData?.role_competency || "-" }}
                </span>
                <span class="badge-custom bg-info-soft text-info">
                  {{ courseData?.role_competency_type || "-" }}
                </span>
              </div>

              <!-- Stats -->
              <div
                class="row mb-4 p-3 rounded"
                style="background-color: #fafafa"
              >
                <div class="col-4">
                  <div class="d-flex align-items-center text-muted">
                    <i class="fe fe-clock me-2" style="font-size: 1.1rem"></i>
                    <div>
                      <small class="d-block" style="font-size: 0.7rem"
                        >Learning Hours</small
                      >
                      <strong class="text-dark"
                        >{{
                          courseData && courseData?.hour
                            ? Number(courseData?.hour)
                            : "-"
                        }}
                        hrs</strong
                      >
                    </div>
                  </div>
                </div>
                <div class="col-4">
                  <div class="d-flex align-items-center text-muted">
                    <i
                      class="fe fe-dollar-sign me-2"
                      style="font-size: 1.1rem"
                    ></i>
                    <div>
                      <small class="d-block" style="font-size: 0.7rem"
                        >Estimated Price</small
                      >
                      <strong class="text-dark"
                        >IDR
                        {{
                          courseData && courseData?.closest_batch_total_price
                            ? compactNumberFormatter(
                                courseData?.closest_batch_total_price,
                              )
                            : "-"
                        }}</strong
                      >
                    </div>
                  </div>
                </div>
                <div class="col-4">
                  <div class="d-flex align-items-center text-muted">
                    <i class="fe fe-users me-2" style="font-size: 1.1rem"></i>
                    <div>
                      <small class="d-block" style="font-size: 0.7rem"
                        >Enrolled</small
                      >
                      <strong class="text-dark"
                        >{{
                          courseData &&
                          courseData?.closest_batch_participant_count !== null &&
                          courseData?.closest_batch_participant_count !== undefined
                            ? courseData?.closest_batch_participant_count
                            : "-"
                        }}
                        /
                        {{
                          courseData &&
                          courseData?.closest_batch_quota !== null &&
                          courseData?.closest_batch_quota !== undefined
                            ? courseData?.closest_batch_quota
                            : "-"
                        }}</strong
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Right Side - Course Image -->
            <div class="col-md-5">
              <div class="course-image-container rounded">
                <img
                  :src="
                    courseData && courseData?.cover_image_path
                      ? `${imageBaseUrl}/attachments/${courseData?.cover_image_path}`
                      : `https://dummyimage.com/300x200/FAFAFA/000000&text=${
                          courseData?.title || 'Course'
                        }`
                  "
                  alt="Course Thumbnail"
                  class="course-image"
                />
              </div>
            </div>
          </div>

          <!-- Tabs -->
          <ul class="nav nav-tabs mb-3" role="tablist">
            <li class="nav-item">
              <a
                class="nav-link active"
                data-bs-toggle="tab"
                href="#description"
              >
                Description
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" data-bs-toggle="tab" href="#attributes">
                Attributes
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" data-bs-toggle="tab" href="#platform">
                Platform
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" data-bs-toggle="tab" href="#schedule">
                Schedule
              </a>
            </li>
          </ul>

          <!-- Tab Content -->
          <div class="tab-content">
            <!-- Description Tab -->
            <div class="tab-pane fade show active" id="description">
              <!-- Service Bond Notice -->
              <div
                class="mb-4"
                v-if="
                  courseData && courseData.hasOwnProperty('is_service_bond')
                "
              >
                <div
                  class="d-flex align-items-center gap-3 p-3 rounded"
                  :class="
                    courseData.is_service_bond
                      ? 'bg-warning-soft border border-warning'
                      : 'bg-success-soft border border-success'
                  "
                >
                  <div class="flex-shrink-0">
                    <i
                      :class="
                        courseData.is_service_bond
                          ? 'fe fe-alert-triangle text-warning'
                          : 'fe fe-check-circle text-success'
                      "
                      style="font-size: 1.5rem"
                    ></i>
                  </div>
                  <div class="flex-grow-1">
                    <h6
                      class="mb-1 font-weight-bold"
                      :class="
                        courseData.is_service_bond
                          ? 'text-warning-dark'
                          : 'text-success-dark'
                      "
                    >
                      {{
                        courseData.is_service_bond
                          ? "Service Bond (Ikatan Dinas)"
                          : "No Service Bond"
                      }}
                    </h6>
                    <p
                      class="mb-0 small"
                      :class="
                        courseData.is_service_bond
                          ? 'text-warning-dark'
                          : 'text-success-dark'
                      "
                    >
                      {{
                        courseData.is_service_bond
                          ? "This training requires a service bond commitment."
                          : "This training does not require any service bond commitment."
                      }}
                    </p>
                  </div>
                </div>
              </div>

              <p class="mb-3" style="line-height: 1.8; font-size: 0.9rem">
                {{
                  courseData && courseData?.description
                    ? courseData?.description
                    : "No description available."
                }}
              </p>

              <!-- Related Competencies -->
              <div
                class="mt-4"
                v-if="
                  courseData &&
                  courseData?.competency &&
                  courseData?.competency.length > 0
                "
              >
                <h6 class="font-weight-bold mb-3">Related Competencies</h6>
                <div class="d-flex gap-2 flex-wrap">
                  <span
                    v-for="(comp, index) in courseData?.competency"
                    :key="index"
                    class="badge bg-white text-dark border px-3 py-2"
                    style="font-weight: 500"
                  >
                    {{ comp.name }} <span class="text-muted">|</span>
                    <i class="fe fe-star text-warning"></i>
                    {{ comp.proficiency[0] }}
                    <!-- <span 
                      v-if="comp.proficiency && comp.proficiency.length > 0"
                      class="badge bg-warning ms-2" 
                      style="border-radius: 50%; width: 20px; height: 20px; padding: 0; display: inline-flex; align-items: center; justify-content: center;">
                      
                    </span> -->
                  </span>
                </div>
                <p class="text-muted mt-3 mb-0" style="font-size: 0.75rem">
                  **Notes: <i class="fe fe-star text-warning"></i> Levels of
                  proficiency 1-5
                </p>
              </div>
            </div>

            <!-- Attributes Tab -->
            <div class="tab-pane fade" id="attributes">
              <div class="row">
                <!-- Left Column -->
                <div class="col-md-6">
                  <!-- Course Number -->
                  <div
                    class="mb-4 py-2 px-3 rounded"
                    style="background-color: #fafafa"
                  >
                    <label class="text-muted small mb-2">Course Number</label>
                    <p class="text-dark font-weight-bold mb-0">
                      {{
                        courseData && courseData?.no_course
                          ? courseData?.no_course
                          : "-"
                      }}
                    </p>
                  </div>

                  <!-- Course Category -->
                  <div
                    class="mb-4 py-2 px-3 rounded"
                    style="background-color: #fafafa"
                  >
                    <label class="text-muted small mb-2">Course Category</label>
                    <p class="text-dark font-weight-bold mb-0">
                      {{
                        courseData && courseData?.training_category
                          ? courseData?.training_category
                          : "-"
                      }}
                    </p>
                  </div>

                  <!-- Course URL -->
                  <div
                    class="mb-4 py-2 px-3 rounded"
                    style="background-color: #fafafa"
                  >
                    <label class="text-muted small mb-2">Course URL</label>
                    <div class="d-flex align-items-center gap-2">
                      <a
                        v-if="courseData && courseData?.website"
                        :href="courseData?.website"
                        target="_blank"
                        class="text-primary text-truncate"
                        style="max-width: 80%; text-decoration: none"
                      >
                        {{ courseData?.website }}
                      </a>
                      <span v-else class="text-muted">-</span>
                      <a
                        v-if="courseData && courseData?.website"
                        :href="courseData?.website"
                        target="_blank"
                        class="btn btn-sm btn-danger d-flex align-items-center justify-content-center"
                        style="
                          width: 32px;
                          height: 32px;
                          padding: 0;
                          border-radius: 4px;
                        "
                      >
                        <i class="fe fe-send" style="font-size: 14px"></i>
                      </a>
                    </div>
                  </div>

                  <!-- Department -->
                  <div
                    class="mb-4 py-2 px-3 rounded"
                    style="background-color: #fafafa"
                  >
                    <label class="text-muted small mb-2">Department</label>
                    <p class="text-dark font-weight-bold mb-0">
                      {{
                        courseData && courseData?.department
                          ? courseData?.department
                          : "-"
                      }}
                    </p>
                  </div>

                  <!-- Division -->
                  <div
                    class="mb-4 py-2 px-3 rounded"
                    style="background-color: #fafafa"
                  >
                    <label class="text-muted small mb-2">Division</label>
                    <p class="text-dark font-weight-bold mb-0">
                      {{
                        courseData && courseData?.division
                          ? courseData?.division
                          : "-"
                      }}
                    </p>
                  </div>
                </div>

                <!-- Right Column -->
                <div class="col-md-6">
                  <!-- Course Type -->
                  <div
                    class="mb-4 py-2 px-3 rounded"
                    style="background-color: #fafafa"
                  >
                    <label class="text-muted small mb-2">Course Type</label>
                    <p class="text-dark font-weight-bold mb-0">
                      {{
                        courseData && courseData?.training_type_name
                          ? courseData?.training_type_name
                          : "-"
                      }}
                    </p>
                  </div>

                  <!-- Certificate Validity Period -->
                  <div
                    class="mb-4 py-2 px-3 rounded"
                    style="background-color: #fafafa"
                  >
                    <label class="text-muted small mb-2"
                      >Certificate Validity Period (Months)</label
                    >
                    <p class="text-dark font-weight-bold mb-0">
                      {{
                        courseData && courseData?.certificate_validity_period
                          ? courseData?.certificate_validity_period
                          : "-"
                      }}
                    </p>
                  </div>

                  <!-- Course Scope -->
                  <div
                    class="mb-4 py-2 px-3 rounded"
                    style="background-color: #fafafa"
                  >
                    <label class="text-muted small mb-2">Course Scope</label>
                    <div>
                      <span
                        v-for="training_scope_name in courseData?.training_scope"
                        :key="training_scope_name"
                        class="badge badge-dark font-weight-bold mr-1"
                      >
                        {{ training_scope_name }}
                      </span>
                    </div>
                  </div>

                  <!-- STEM Category -->
                  <div
                    class="mb-4 py-2 px-3 rounded"
                    style="background-color: #fafafa"
                  >
                    <label class="text-muted small mb-2">STEM Category</label>
                    <p class="text-dark font-weight-bold mb-0">
                      {{
                        courseData && courseData?.stem_category
                          ? courseData?.stem_category
                          : "-"
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <!-- Platform Tab -->
            <div class="tab-pane fade" id="platform">
              <div class="row">
                <!-- Left Column -->
                <div class="col-md-6">
                  <!-- Platform Name -->
                  <div
                    class="mb-4 py-2 px-3 rounded"
                    style="background-color: #fafafa"
                  >
                    <label class="text-muted small mb-2">Platform Name</label>
                    <p class="text-dark font-weight-bold mb-0">
                      {{
                        courseData && courseData?.platform
                          ? courseData?.platform
                          : "-"
                      }}
                    </p>
                  </div>

                  <!-- Training Provider (LDP) -->
                  <div
                    class="mb-4 py-2 px-3 rounded"
                    style="background-color: #fafafa"
                  >
                    <label class="text-muted small mb-2"
                      >Training Provider</label
                    >
                    <p class="text-dark font-weight-bold mb-0">
                      {{
                        courseData && courseData?.provider_name
                          ? courseData?.provider_name
                          : "-"
                      }}
                    </p>
                  </div>

                  <!-- Provider Webiste -->
                  <div
                    class="mb-4 py-2 px-3 rounded"
                    style="background-color: #fafafa"
                  >
                    <label class="text-muted small mb-2"
                      >Provider Webiste</label
                    >
                    <p class="text-dark font-weight-bold mb-0">
                      {{
                        courseData && courseData?.provider_website
                          ? courseData?.provider_website
                          : "-"
                      }}
                    </p>
                  </div>

                  <!-- Email -->
                  <div
                    class="mb-4 py-2 px-3 rounded"
                    style="background-color: #fafafa"
                  >
                    <label class="text-muted small mb-2">Email</label>
                    <p class="text-dark font-weight-bold mb-0">
                      {{
                        courseData && courseData?.provider_email
                          ? courseData?.provider_email
                          : "-"
                      }}
                    </p>
                  </div>
                </div>

                <!-- Right Column -->
                <div class="col-md-6">
                  <!-- Provider Name (LSP) -->
                  <div
                    class="mb-4 py-2 px-3 rounded"
                    style="background-color: #fafafa"
                  >
                    <label class="text-muted small mb-2"
                      >Provider Name (LSP)</label
                    >
                    <p class="text-dark font-weight-bold mb-0">
                      {{
                        courseData && courseData?.lsp_name
                          ? courseData?.lsp_name
                          : "-"
                      }}
                    </p>
                  </div>

                  <!-- Address -->
                  <div
                    class="mb-4 py-2 px-3 rounded"
                    style="background-color: #fafafa"
                  >
                    <label class="text-muted small mb-2">Address</label>
                    <p class="text-dark font-weight-bold mb-0">
                      {{
                        courseData && courseData?.provider_address
                          ? courseData?.provider_address
                          : "-"
                      }}
                    </p>
                  </div>

                  <!-- Contact Person -->
                  <div
                    class="mb-4 py-2 px-3 rounded"
                    style="background-color: #fafafa"
                  >
                    <label class="text-muted small mb-2">Contact Person</label>
                    <p class="text-dark font-weight-bold mb-0">
                      {{
                        courseData && courseData?.provider_contact_person
                          ? courseData?.provider_contact_person
                          : "-"
                      }}
                    </p>
                  </div>

                  <!-- Phone -->
                  <div
                    class="mb-4 py-2 px-3 rounded"
                    style="background-color: #fafafa"
                  >
                    <label class="text-muted small mb-2">Phone</label>
                    <p class="text-dark font-weight-bold mb-0">
                      {{
                        courseData && courseData?.provider_phone
                          ? courseData?.provider_phone
                          : "-"
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <!-- Schedule Tab -->
            <div class="tab-pane fade" id="schedule">
              <!-- Filter Section -->
              <div class="row mb-3">
                <div class="col-md-4">
                  <v-select
                    v-model="idpPeriod"
                    :options="listIdpPeriod"
                    :reduce="(e) => e"
                    label="label"
                    placeholder="Select IDP Period"
                    @input="selectIdpPeriod"
                  >
                  </v-select>
                </div>
                <div class="col-md-4">
                  <div class="d-flex align-items-center gap-2">
                    <label
                      class="text-muted small mb-0"
                      style="white-space: nowrap"
                      >Rows per page:</label
                    >
                    <select
                      v-model.number="perPage"
                      class="form-control form-control-sm"
                      style="max-width: 100px"
                    >
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="15">15</option>
                      <option value="20">20</option>
                      <option value="50">50</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-4 text-right">
                  <button
                    class="btn btn-danger btn-sm"
                    @click="openAddBatchModal"
                  >
                    <i class="fe fe-plus me-1"></i>
                    Add New Batch
                  </button>
                </div>
              </div>

              <!-- Schedule Table -->
              <div class="table-responsive table-dropdown-container">
                <table class="table table-hover">
                  <thead class="rounded" style="background-color: #f8f9fa">
                    <tr>
                      <th class="text-muted small font-weight-normal">BATCH</th>
                      <th class="text-muted small font-weight-normal">QUOTA</th>
                      <th class="text-muted small font-weight-normal">
                        USED QUOTA
                      </th>
                      <th class="text-muted small font-weight-normal">
                        REMAINING QUOTA
                      </th>
                      <th class="text-muted small font-weight-normal">
                        PENYELENGGARA
                      </th>
                      <th class="text-muted small font-weight-normal">
                        SCHEDULE
                      </th>
                      <th class="text-muted small font-weight-normal">
                        STATUS
                      </th>
                      <th class="text-muted small font-weight-normal">
                        ACTION
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <!-- Empty State -->
                    <tr
                      v-if="
                        !courseData ||
                        !courseData?.batches ||
                        courseData?.batches.length === 0
                      "
                    >
                      <td colspan="8" class="text-center py-5">
                        <i
                          class="fe fe-inbox text-muted"
                          style="font-size: 3rem"
                        ></i>
                        <p class="text-muted mt-2">No batches available</p>
                      </td>
                    </tr>

                    <!-- Batch Rows -->
                    <tr
                      v-for="(batch, index) in paginatedBatches"
                      :key="batch.id || index"
                    >
                      <td class="align-middle">{{ formatBatchLabel(batch) }}</td>
                      <td class="align-middle">{{ batch.quota || "-" }}</td>
                      <td class="align-middle">
                        {{
                          batch?.participant_count !== null &&
                          batch?.participant_count !== undefined
                            ? batch?.participant_count
                            : 0
                        }}
                      </td>
                      <td class="align-middle">
                        {{
                          batch?.remaining_quota !== null &&
                          batch?.remaining_quota !== undefined
                            ? batch?.remaining_quota
                            : "-"
                        }}
                      </td>
                      <td class="align-middle">
                        {{ formatPenyelenggara(batch.penyelenggara) }}
                      </td>
                      <td class="align-middle">
                        <div
                          v-if="batch.schedules && batch.schedules.length > 0"
                        >
                          <div
                            v-for="(schedule, idx) in batch.schedules"
                            :key="idx"
                            :class="{ 'mt-2': idx > 0 }"
                          >
                            <strong class="d-block">{{
                              formatLongDate(schedule.date) || "-"
                            }}</strong>
                            <small class="text-muted"
                              >{{ formatTime(schedule.start_time) || "-" }} -
                              {{ formatTime(schedule.end_time) || "-" }}</small
                            >
                          </div>
                        </div>
                        <span v-else class="text-muted">No schedule</span>
                      </td>
                      <td class="align-middle">
                        <span :class="getStatusBadgeClass(batch.status)">
                          {{ formatStatus(batch.status) }}
                        </span>
                      </td>
                      <td class="align-middle">
                        <b-dropdown
                          variant="link"
                          no-caret
                          right
                          toggle-class="text-decoration-none p-0"
                          boundary="viewport"
                          :popper-opts="{ strategy: 'fixed' }"
                        >
                          <template #button-content>
                            <button
                              class="btn btn-sm btn-light d-flex align-items-center justify-content-center"
                              style="width: 36px; height: 36px; padding: 0"
                            >
                              <i class="fe fe-more-vertical" style="font-size: 16px"></i>
                            </button>
                          </template>

                          <b-dropdown-item @click="openParticipantModal(batch)">
                            <i class="fe fe-users text-info me-2"></i>
                            View Participants
                          </b-dropdown-item>

                          <b-dropdown-item
                            v-if="batch.status === 'completed'"
                            @click="openConfirmationCourse(batch)"
                          >
                            <i class="fe fe-dollar-sign text-success me-2"></i>
                            Course Confirmation
                          </b-dropdown-item>

                          <b-dropdown-item
                            v-if="batch.ulearning_url"
                            @click="openUlearningUrl(batch.ulearning_url)"
                          >
                            <i class="fe fe-external-link text-primary me-2"></i>
                            Open in Ulearning
                          </b-dropdown-item>

                          <b-dropdown-divider></b-dropdown-divider>

                          <b-dropdown-item @click="confirmDuplicateBatch(batch)">
                            <i class="fe fe-copy text-secondary me-2"></i>
                            Duplicate Batch
                          </b-dropdown-item>

                          <b-dropdown-item @click="editBatch(batch)">
                            <i class="fe fe-edit text-warning me-2"></i>
                            Edit Batch
                          </b-dropdown-item>

                          <b-dropdown-item
                            :disabled="batch.status === 'compeleted'"
                            @click="openConfirmationDeleteBatch(batch)"
                          >
                            <i class="fe fe-trash-2 text-danger me-2"></i>
                            Delete Batch
                          </b-dropdown-item>
                        </b-dropdown>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Pagination -->
              <div
                class="d-flex justify-content-between align-items-center mt-3"
              >
                <div>
                  <small class="text-muted"
                    >Showing {{ paginationStartItem }} to
                    {{ paginationEndItem }} of {{ totalBatches }}</small
                  >
                </div>
                <nav aria-label="Schedule pagination">
                  <ul class="pagination pagination-sm mb-0">
                    <li :class="['page-item', { disabled: currentPage === 1 }]">
                      <button
                        class="page-link"
                        :disabled="currentPage === 1"
                        @click="currentPage = Math.max(1, currentPage - 1)"
                      >
                        <i class="fe fe-chevron-left"></i>
                      </button>
                    </li>
                    <li
                      v-for="page in totalPages"
                      :key="page"
                      :class="['page-item', { active: currentPage === page }]"
                    >
                      <button class="page-link" @click="currentPage = page">
                        {{ page }}
                      </button>
                    </li>
                    <li
                      :class="[
                        'page-item',
                        { disabled: currentPage === totalPages },
                      ]"
                    >
                      <button
                        class="page-link"
                        :disabled="currentPage === totalPages"
                        @click="
                          currentPage = Math.min(totalPages, currentPage + 1)
                        "
                      >
                        <i class="fe fe-chevron-right"></i>
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Participant Modal -->
    <modal-participant
      :batch-id="selectedBatchId"
      :batch-status="selectedBatchStatus"
      :platform="courseData?.platform"
      :course-title="courseData?.title"
      :batch-schedules="selectedBatch?.schedules"
      @reload-participants="reloadParticipants"
    />

    <!-- Add/Edit Batch Modal -->
    <modal-add-batch
      ref="modalAddBatch"
      :platform="courseData?.platform"
      :competency-type="courseData?.role_competency_type"
      :course-id="courseData?.id"
      :has-mapped-moodle-course="hasMappedMoodleCourse"
      :wait-for-api-response="true"
      @batch-added="onBatchAdded"
      @batch-updated="onBatchUpdated"
    />
  </b-modal>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ModalParticipant from "./ModalParticipant.vue";
import ModalAddBatch from "./ModalAddBatch.vue";
import { compactNumberFormatter } from "@/utils/currencyFormatter";
import { formatLongDate, formatTime } from "@/utils/dateFormatter";
import { getBatchMutationErrorMessage } from "@/utils/error-message";
import { formatBatchLabel } from "@/utils/batchIdentity";

export default {
  name: "ModalCourseDetail",
  components: {
    ModalParticipant,
    ModalAddBatch,
  },
  props: {
    selectedCourse: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapGetters("courseCatalog", {
      courseDetail: "getCourseDetail",
      isLoading: "getLoading",
    }),
    courseData() {
      return this.courseDetail || this.selectedCourse;
    },
    totalBatches() {
      return this.courseData?.batches?.length || 0;
    },
    isMoodlePlatform() {
      const normalizedPlatform = (this.courseData?.platform || "").toLowerCase();
      return [
        "bib academy",
        "ugems university",
        "ugems univ",
        "gems univ",
        "my learning",
      ].includes(normalizedPlatform);
    },
    hasMappedMoodleCourse() {
      return (this.courseData?.batches || []).some(
        (batch) => batch.ulearning_course_id || batch.ulearning_url,
      );
    },
    sourceMoodleCourseId() {
      const mappedBatches = (this.courseData?.batches || []).filter(
        (batch) => batch.ulearning_course_id,
      );

      if (!mappedBatches.length) return null;

      const [latestMappedBatch] = mappedBatches.sort((a, b) => {
        const batchDiff = Number(b.batch || 0) - Number(a.batch || 0);
        if (batchDiff !== 0) return batchDiff;
        return Number(b.id || 0) - Number(a.id || 0);
      });

      return latestMappedBatch.ulearning_course_id;
    },
    paginatedBatches() {
      if (!this.courseData?.batches) return [];
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.courseData.batches.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.totalBatches / this.perPage);
    },
    paginationStartItem() {
      return this.totalBatches === 0
        ? 0
        : (this.currentPage - 1) * this.perPage + 1;
    },
    paginationEndItem() {
      return Math.min(this.currentPage * this.perPage, this.totalBatches);
    },
  },
  data() {
    return {
      imageBaseUrl: process.env.VUE_APP_API_URL_UGEMS_UNIV,
      idpPeriod: null,
      listIdpPeriod: [],
      participants: null,
      selectedBatchId: null,
      selectedBatchStatus: null,
      selectedBatch: null,
      perPage: 5,
      currentPage: 1,
    };
  },
  watch: {
    selectedCourse: {
      immediate: true,
      handler(newCourse) {
        if (newCourse && newCourse.id) {
          this.currentPage = 1;
          this.loadCourseDetail(newCourse.id);
        }
      },
    },
    "courseData.batches": {
      handler() {
        if (this.currentPage > this.totalPages && this.totalPages > 0) {
          this.currentPage = this.totalPages;
        }
      },
    },
    perPage() {
      this.currentPage = 1;
    },
  },
  methods: {
    ...mapActions("courseCatalog", ["getCourseById"]),
    compactNumberFormatter,
    formatLongDate,
    formatTime,
    formatBatchLabel,
    async loadCourseDetail(courseId) {
      try {
        await this.getCourseById(courseId);
      } catch (error) {
        console.error("Error loading course detail:", error);
        this.$swal("Error", "Detail pelatihan belum berhasil dimuat", "error");
      }
    },

    formatPenyelenggara(value) {
      const organizerLabels = {
        "PT BORNEO INDOBARA": "Borneo Indobara",
        "PT CIPTA KRIDATAMA": "Cipta Kridatama",
        "PT TAMA MULIA RESOURCES": "Tama Mulia Resources",
        "PT PUTRA PERKASA ABADI": "Putra Perkasa Abadi",
      };

      return organizerLabels[value] || value || "-";
    },

    // Format status: remove underscore and capitalize each word
    formatStatus(status) {
      if (!status) return "";
      return status
        .split("_")
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
        )
        .join(" ");
    },

    // Get badge class based on status
    getStatusBadgeClass(status) {
      if (!status) return "badge badge-pill px-3 py-2";

      const normalizedStatus = status.toLowerCase();

      if (normalizedStatus === "upcoming") {
        return "badge badge-pill px-3 py-2 badge-warning";
      } else if (normalizedStatus === "in_progress") {
        return "badge badge-pill px-3 py-2 badge-info";
      } else if (
        normalizedStatus === "compeleted" ||
        normalizedStatus === "completed"
      ) {
        return "badge badge-pill px-3 py-2 badge-success";
      }

      // Default
      return "badge badge-pill px-3 py-2 badge-secondary";
    },

    editCourse() {
      // Emit to parent with full course data
      this.$emit("edit-course", this.courseData);
    },

    openUlearningUrl(url) {
      if (url) {
        window.open(url, '_blank');
      }
    },

    deleteCourse() {
      // Pass courseData untuk di-store di parent
      this.$emit("delete-course", this.courseData);
    },

    openConfirmationCourse(batchData) {
      console.log("🔔 openConfirmationCourse called with batch:", batchData);

      // Emit event setelah modal ditutup
      setTimeout(() => {
        console.log("⏰ Emitting open-confirmation-course event");
        this.$emit("open-confirmation-course", batchData);
      }, 300);
    },

    openConfirmationDeleteBatch(batchData) {
      console.log(
        "🔔 openConfirmationDeleteBatch called with batch:",
        batchData,
      );

      // Emit event setelah modal ditutup
      setTimeout(() => {
        console.log("⏰ Emitting open-confirmation-delete-batch event");
        this.$emit("open-confirmation-delete-batch", batchData);
      }, 300);
    },

    async confirmDuplicateBatch(batch) {
      const result = await this.$swal({
        title: "Duplikasi Batch?",
        html: `
          <p class="mb-2">Apakah Anda yakin ingin menduplikasi batch ini?</p>
          <div class="alert alert-warning mt-3 text-left" style="font-size: 0.875rem; text-align: left;">
            <i class="fe fe-info me-2"></i>
            <strong>Yang di-clone:</strong> struktur course Moodle (materi, activity, quiz, filter).
            <ul class="mb-0 mt-2 pl-3">
              <li>Peserta <strong>tidak</strong> ikut ter-copy. Enroll ulang lewat alur enroll yang ada.</li>
              <li>Jadwal tidak diduplikasi. Sistem menambahkan jadwal default 1 bulan dari hari ini.</li>
              <li>Clone Moodle bisa memakan waktu hingga sekitar 5 menit. Jangan tutup halaman selama proses berjalan.</li>
            </ul>
          </div>
        `,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Ya, duplikasi",
        cancelButtonText: "Batal",
        confirmButtonColor: "#e63757",
        cancelButtonColor: "#6c757d",
        showLoaderOnConfirm: true,
        allowEscapeKey: () => !this.$swal.isLoading(),
        allowOutsideClick: () => !this.$swal.isLoading(),
        preConfirm: async () => {
          this.$swal.update({
            html: `
              <p>Sedang menduplikasi batch dan clone course Moodle.</p>
              <p class="text-muted mb-0" style="font-size: 0.875rem;">Proses ini bisa memakan waktu hingga sekitar 5 menit.</p>
            `,
          });
          try {
            await this.$store.dispatch(
              "courseCatalog/duplicateBatch",
              batch.id,
            );
            return { success: true };
          } catch (error) {
            this.$swal.showValidationMessage(
              getBatchMutationErrorMessage(
                error,
                "Batch belum berhasil diduplikasi",
              ),
            );
            return { success: false };
          }
        },
      });

      if (result.isConfirmed && result.value && result.value.success) {
        await this.loadCourseDetail(this.courseData.id);

        this.$swal({
          title: "Success",
          text: "Batch berhasil diduplikasi. Peserta belum ikut ter-copy; enroll ulang lewat alur enroll.",
          icon: "success",
          confirmButtonColor: "#e63757",
        });
      }
    },

    openParticipantModal(batch) {
      this.participants = batch.participants || [];
      this.selectedBatchId = batch.id;
      this.selectedBatchStatus = batch.status;
      this.selectedBatch = batch || null;

      // Use $nextTick to ensure the prop update is processed before showing modal
      this.$nextTick(() => {
        this.$bvModal.show("modal-participant");
      });
    },

    async reloadParticipants() {
      // Reload the course detail to get updated participants
      if (this.courseData && this.courseData.id) {
        await this.loadCourseDetail(this.courseData.id);
      }
    },

    editBatch(batch) {
      // Transform batch data to match ModalAddBatch format
      const batchData = {
        id: batch.id,
        courseMethod: batch.training_method_id,
        coursePrice: batch.course_price?.toString() || "",
        coursePriceCurrency: batch.course_price_currency || "IDR",
        accommodationPrice: batch.accomodation_price?.toString() || "",
        accommodationCurrency: batch.accomodation_price_currency || "IDR",
        transportPrice: batch.transportation_price?.toString() || "",
        transportCurrency: batch.transportation_price_currency || "IDR",
        location: batch.location || "",
        quota: batch.quota?.toString() || "",
        passing_score: batch.passing_score?.toString() || "",
        penyelenggara: batch.penyelenggara || "PT BORNEO INDOBARA",
        certificate_id: batch.certificate_id,
        schedules:
          batch.schedules?.map((schedule) => ({
            id: schedule.id,
            date: schedule.date || "",
            startTime: schedule.start_time
              ? schedule.start_time.substring(0, 5)
              : "",
            endTime: schedule.end_time ? schedule.end_time.substring(0, 5) : "",
            status: schedule.status,
          })) || [],
      };

      // Load batch data into modal
      if (this.$refs.modalAddBatch && this.$refs.modalAddBatch.loadBatchData) {
        this.$refs.modalAddBatch.loadBatchData(batchData);
      }

      this.$bvModal.show("modal-add-batch");
    },

    openAddBatchModal() {
      // Reset the modal to create mode
      if (this.$refs.modalAddBatch && this.$refs.modalAddBatch.resetForm) {
        this.$refs.modalAddBatch.resetForm();
      }
      this.$bvModal.show("modal-add-batch");
    },

    async onBatchAdded(batchData) {
      try {
        // Transform data to API format
        const payload = {
          method: batchData.courseMethod,
          course_price_currency: batchData.coursePriceCurrency,
          course_price: parseInt(batchData.coursePrice) || 0,
          accomodation_price_currency: batchData.accommodationCurrency,
          accomodation_price: parseInt(batchData.accommodationPrice) || 0,
          transportation_price_currency: batchData.transportCurrency,
          transportation_price: parseInt(batchData.transportPrice) || 0,
          passing_score: batchData.passing_score
            ? parseInt(batchData.passing_score)
            : null,
          penyelenggara: batchData.penyelenggara || "PT BORNEO INDOBARA",
          location: batchData.location,
          quota: parseInt(batchData.quota) || 0,
          certificate_id: batchData.certificate_id,
          schedules: (batchData.schedules || []).map((schedule) => ({
            date: schedule.date,
            start_time: schedule.startTime,
            end_time: schedule.endTime,
          })),
        };

        const hadMappedMoodleCourse = this.hasMappedMoodleCourse;
        if (this.isMoodlePlatform && this.sourceMoodleCourseId) {
          payload.source_moodle_course_id = this.sourceMoodleCourseId;
        }

        await this.$store.dispatch("courseCatalog/createBatch", {
          trainingId: this.courseData.id,
          data: payload,
        });

        await this.loadCourseDetail(this.courseData.id);

        this.$refs.modalAddBatch.handleSuccess();

        const successMessage = this.isMoodlePlatform
          ? hadMappedMoodleCourse
            ? "Batch berhasil dibuat. Course Moodle di-clone dari source yang sudah ter-mapping. Peserta perlu di-enroll ulang."
            : "Batch berhasil dibuat. Course Moodle masih kosong — isi materi di Moodle pada batch ini sebelum membuat batch berikutnya."
          : "Batch berhasil dibuat";

        this.$swal("Success", successMessage, "success");

        this.$emit("batch-created-success");
      } catch (error) {
        console.error("Error creating batch:", error);
        const errorMessage = getBatchMutationErrorMessage(
          error,
          "Batch belum berhasil dibuat",
        );

        this.$refs.modalAddBatch.handleError();

        this.$swal("Error", errorMessage, "error");
      }
    },

    async onBatchUpdated(batchData) {
      try {
        // Transform data to API format
        const payload = {
          method: batchData.courseMethod,
          course_price_currency: batchData.coursePriceCurrency,
          course_price: parseInt(batchData.coursePrice) || 0,
          accomodation_price_currency: batchData.accommodationCurrency,
          accomodation_price: parseInt(batchData.accommodationPrice) || 0,
          transportation_price_currency: batchData.transportCurrency,
          transportation_price: parseInt(batchData.transportPrice) || 0,
          passing_score: batchData.passing_score
            ? parseInt(batchData.passing_score)
            : null,
          penyelenggara: batchData.penyelenggara || "PT BORNEO INDOBARA",
          location: batchData.location,
          quota: parseInt(batchData.quota) || 0,
          certificate_id: batchData.certificate_id,
          schedules: (batchData.schedules || []).map((schedule) => ({
            id: schedule.id, // Include id for existing schedules, undefined for new ones
            date: schedule.date,
            start_time: schedule.startTime,
            end_time: schedule.endTime,
          })),
        };

        // Make PUT request to update batch
        await this.$store.dispatch("courseCatalog/updateBatch", {
          id: batchData.id,
          data: payload,
        });

        // Reload course detail to get updated data
        await this.loadCourseDetail(this.courseData.id);

        // Notify child component of success
        this.$refs.modalAddBatch.handleSuccess();

        this.$swal(
          "Success",
          "Batch berhasil diperbarui",
          "success",
        );

        // Emit event to parent to reload the course list/data
        this.$emit("batch-updated-success");
      } catch (error) {
        console.error("Error updating batch:", error);
        const errorMessage =
          error.response?.data?.error ||
          error.response?.data?.message ||
          "Batch belum berhasil diperbarui";

        // Notify child component of error
        this.$refs.modalAddBatch.handleError();

        this.$swal("Error", errorMessage, "error");
      }
    },

    // Get icon class based on training type
    getTrainingTypeIcon(trainingType) {
      const type = trainingType?.toLowerCase() || "";

      if (type.includes("certification") && !type.includes("semi")) {
        return "fe fe-file-text"; // Certification
      } else if (type.includes("semi")) {
        return "fe fe-shield"; // Semi Certification
      } else if (type.includes("training")) {
        return "fe fe-user"; // Training
      }

      return "fe fe-award"; // Default icon
    },

    // Get IDP Period list
    getIdpPeriod() {
      this.$store.dispatch("idpPeriod/getIdpPeriod").then((res) => {
        this.listIdpPeriod = res.data.map((item) => {
          if (item.status === "open") {
            this.idpPeriod = {
              id: item.id,
              status: item.status,
              label: `${item.start_date} - ${item.end_date}`,
              start_date: item.start_date,
              end_date: item.end_date,
              min_hours: item.min_hours,
            };
          }
          return {
            id: item.id,
            status: item.status,
            label: `${item.start_date} - ${item.end_date}`,
            start_date: item.start_date,
            end_date: item.end_date,
            min_hours: item.min_hours,
          };
        });
      });
    },

    // Handle IDP Period selection change
    selectIdpPeriod() {
      // When an IDP period is selected, fetch course detail for the
      // currently shown course with a `year` query param derived
      // from the selected period's `start_date` (format yyyy-mm-dd).
      console.log("Selected IDP Period:", this.idpPeriod);

      try {
        if (!this.courseData || !this.courseData.id) return;

        const startDate = this.idpPeriod?.start_date;
        if (!startDate) {
          // If no start_date, just reload without params
          this.getCourseById(this.courseData.id);
          return;
        }

        // Extract year part from yyyy-mm-dd
        const year = String(startDate).split("-")[0];

        // Call Vuex action with { id, params } so the API will receive ?year=YYYY
        this.getCourseById({ id: this.courseData.id, params: { year } });
      } catch (err) {
        console.error("Error selecting IDP period:", err);
      }
    },
  },

  mounted() {
    this.getIdpPeriod();
  },
};
</script>

<style scoped>
.modal-body-custom {
  padding: 0;
}

/* Badge Styles */
.badge-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border-radius: 50%;
  font-size: 0.75rem;
}

.badge-custom {
  padding: 0.35rem 0.75rem;
  font-size: 0.75rem;
  font-weight: 600;
  border-radius: 0.35rem;
}

/* Soft Badge Colors */
.bg-danger-soft {
  background-color: #fce4e4;
}

.text-danger {
  color: #e63757 !important;
}

.bg-warning-soft {
  background-color: #fef5e4;
}

.text-warning {
  color: #f6c343 !important;
}

.text-warning-dark {
  color: #d39e00 !important;
}

.bg-info-soft {
  background-color: #e4f4f7;
}

.text-info {
  color: #39afd1 !important;
}

.bg-success-soft {
  background-color: #d4f6dd;
}

.text-success-dark {
  color: #198754 !important;
}

.border-warning {
  border-color: #f6c343 !important;
}

.border-success {
  border-color: #00d97e !important;
}

.bg-success {
  background-color: #00d97e !important;
}

.bg-danger {
  background-color: #e63757 !important;
}

/* Tab Styles */
.nav-tabs {
  border-bottom: 1px solid #dee2e6;
}

.nav-tabs .nav-link {
  color: #718096;
  font-weight: 500;
  border: none !important;
  border-bottom: 3px solid transparent !important;
  padding: 0.75rem 1rem;
  background: transparent !important;
}

.nav-tabs .nav-link:hover {
  border-color: transparent transparent #dee2e6 transparent !important;
  color: #4a5568;
}

.nav-tabs .nav-link.active {
  color: #e63757 !important;
  font-weight: 600;
  border-bottom: 3px solid #e63757 !important;
  background: transparent !important;
}

.tab-content {
  padding-top: 1rem;
}

/* Schedule Table Styles */
.table-dropdown-container {
  overflow-x: auto;
  overflow-y: visible;
}

.table {
  margin-bottom: 0;
}

.table thead th {
  border-bottom: 2px solid #dee2e6;
  padding: 0.75rem 1rem;
  font-size: 0.75rem;
  letter-spacing: 0.5px;
}

.table tbody td {
  padding: 1rem;
  vertical-align: middle;
  border-bottom: 1px solid #f1f1f1;
}

.table-hover tbody tr:hover {
  background-color: #f8f9fa;
}

/* Status Badge Styles */
.badge-warning {
  background-color: #fef5e4 !important;
  color: #f6c343 !important;
  font-weight: 500;
}

.badge-info {
  background-color: #e4f4f7 !important;
  color: #39afd1 !important;
  font-weight: 500;
}

.badge-success {
  background-color: #d4edda !important;
  color: #00d97e !important;
  font-weight: 500;
}

.badge-secondary {
  background-color: #e9ecef !important;
  color: #6c757d !important;
  font-weight: 500;
}

/* Pagination Styles */
.pagination {
  gap: 0.25rem;
}

.pagination .page-link {
  color: #2c7be5;
  border: 1px solid #dee2e6;
  padding: 0.375rem 0.75rem;
  border-radius: 0.25rem;
  min-width: 36px;
  text-align: center;
}

.pagination .page-item.active .page-link {
  background-color: #e63757;
  border-color: #e63757;
  color: white;
}

.pagination .page-item.disabled .page-link {
  cursor: not-allowed;
  opacity: 0.5;
  background-color: transparent;
}

.pagination .page-link:hover:not(.disabled) {
  background-color: #f8f9fa;
}

/* Button Styles */
.btn-warning {
  background-color: #ffc107;
  border-color: #ffc107;
  color: #000;
}

.btn-warning:hover {
  background-color: #e0a800;
  border-color: #d39e00;
}

/* Dropdown Menu Styles */
.dropdown-menu {
  border: 1px solid #dee2e6;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  min-width: 200px;
}

.dropdown-item {
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  color: #495057;
  transition: all 0.15s ease-in-out;
}

.dropdown-item:hover:not(:disabled) {
  background-color: #f8f9fa;
  color: #16181b;
}

.dropdown-item:active {
  background-color: #e9ecef;
}

.dropdown-item:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.dropdown-item i {
  width: 20px;
  display: inline-block;
}

.dropdown-divider {
  margin: 0.5rem 0;
}

/* Course Image Landscape Container */
.course-image-container {
  position: relative;
  width: 100%;
  padding-top: 56.25%; /* 16:9 Aspect Ratio for landscape */
  overflow: hidden;
  background-color: #fafafa;
}

.course-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
